import { SLIDE_LIST } from '../maps';
import { MAX_SLIDE_NUMBER } from '../constants';

export const getIndexFromLocation = (location) => {
  const parts = location.pathname.split(/presentation\//);
  
  if (parts.length === 1) {
    replaceUri();
    return 0;
  }

  const slug = parts.pop().replace(/\/$/, '');
  const hasSlug = SLIDE_LIST.filter((slide) => slide.slug === slug).length > 0;

  if (hasSlug === false) {
    replaceUri();
    return 0;
  }

  const slideNumber = getIndexBySlug(slug);

  if (slideNumber < 0 || slideNumber > MAX_SLIDE_NUMBER) {
    replaceUri();
    return 1;
  }

  return slideNumber;
};

export const getSlugByIndex = (index) => {
  for (const [idx, slide] of SLIDE_LIST.entries()) {
    if (index === idx) {
      return slide.slug;
    }
  }
  return '';
};

export const getIndexBySlug = (slug) => {
  for (const [index, slide] of SLIDE_LIST.entries()) {
    if (slug === slide.slug) {
      return index;
    }
  }
  return 1;
};

const replaceUri = () => {
  // https://www.gatsbyjs.org/docs/debugging-html-builds/#how-to-check-if-window-is-defined
  if (typeof window === 'undefined') {
    return;
  }

  window.history.replaceState({}, 'E-Paper-Qualitäten', '/presentation');
};
